/**
 @typedef MembershipRedemptionResource
 @type {Object}
 @property {function(object, function, function)} query
 */

/**
 * @param $resource
 * @param apiRequestParams
 * @param {AppConfig} appConfig
 */
const MembershipRedemptionResource = function ($resource, apiRequestParams, appConfig) {
    return $resource(
        appConfig.apiBaseUrl + 'membershipredemptions/',
        apiRequestParams.defaults(),
        {}
    );
};

module.exports = MembershipRedemptionResource;
